$(function () {
	$(document).on('click', '[data-l]', function (e) {
		e.preventDefault();
		const letter = $(this).data('l');

		$(this).addClass('is-active')
			.siblings()
			.removeClass('is-active');

		const $dictionary = $(this).closest('.dictionary').find('.b-dictionary');

		$(`[data-l="${letter}"]`, $dictionary)
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');
	});

	$('.b-dictionary').each(function () {
		if ($(this).find('.b-dictionary__dropdown').length > 0) {

			var $context = $(this),
				$word = $('.b-dictionary__word', $context);

      // хак для column-count при перестроение при раскрытии
      wrapItems($context);

      window.addEventListener('resize', function () {
        $('.b-dictionary__item', $context).unwrap().unwrap();
        wrapItems($context);
      });

			$word.each(function () {
				var $link = $(this).find('.b-dictionary__link'),
					$dropdown = $(this).find('.b-dictionary__dropdown');
				$link.on('click', function (e) {
					e.preventDefault();
					$(this).toggleClass('is-active');
					$dropdown.toggle();
				})
			})
		}
	});

	function wrapItems($context) {
    let column = {};
    $('.b-dictionary__item', $context).each(function () {
      const left = this.offsetLeft;
      if (!column.hasOwnProperty(left)) {
        column[left] = []
      }
      column[left].push(this);
    });

    for (const items in column) {
      if (!column.hasOwnProperty(items)) {
        continue;
      }

      $(column[items]).wrapAll(('<li class="b-dictionary__fixed-item"><ul></ul></li>'));
    }

    column = null;
  }
});
